import { render, staticRenderFns } from "./manage-booking-order-items-my-account.vue?vue&type=template&id=27d20ec3"
import script from "./manage-booking-order-items-my-account.vue?vue&type=script&lang=ts"
export * from "./manage-booking-order-items-my-account.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports